function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire6588"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire6588"] = parcelRequire;
}
parcelRequire.register("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $18c11f3350a906ea$export$f7ad0328861e2f03, (v) => $18c11f3350a906ea$export$f7ad0328861e2f03 = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = {};
function $18c11f3350a906ea$var$register(pairs) {
    var keys = Object.keys(pairs);
    for(var i = 0; i < keys.length; i++)$18c11f3350a906ea$var$mapping[keys[i]] = pairs[keys[i]];
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping[id];
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return resolved;
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

var $dad37f3c902dd950$exports = {};

(parcelRequire("27Lyk")).register(JSON.parse('{"aT88m":"index.31053e86.js","4uMwD":"favicon-32x32.6b1db583.png","gRhJ5":"android-chrome-512x512.31ca089d.png"}'));

///// Component /////
class $af3cb048de45ff56$export$16fa2f45be04daa8 {
    constructor(payload = {}){
        const { tagName: tagName = "div", props: props = {}, state: state = {} } = payload;
        this.el = document.createElement(tagName); // 컴포넌트의 최상위 요소
        this.props = props; // 컴포넌트가 사용될 때 부모 컴포넌트에서 받는 데이터
        this.state = state; // 컴포넌트 안에서 사용할 데이터
        this.render();
    }
    render() {
    // 컴포넌트를 렌더링하는 함수
    // ...
    }
}
// 페이지 렌더링!
function $af3cb048de45ff56$var$routeRender(routes) {
    // 접속할 때 해시 모드가 아니면(해시가 없으면) /#/로 리다이렉트!
    if (!location.hash) history.replaceState(null, "", "/#/"); // (상태, 제목, 주소)
    const routerView = document.querySelector("router-view");
    const [hash, queryString = ""] = location.hash.split("?"); // 물음표를 기준으로 해시 정보와 쿼리스트링을 구분
    const query = queryString.split("&").reduce((acc, cur)=>{
        const [key, value] = cur.split("=");
        acc[key] = value;
        return acc;
    }, {});
    history.replaceState(query, ""); // (상태, 제목)
    // 2) 현재 라우트 정보를 찾아서 렌더링!
    const currentRoute = routes.find((route)=>{
        return new RegExp(`${route.path}/?$`).test(hash);
    });
    if (routerView) {
        routerView.innerHTML = "";
        currentRoute && routerView.append(new currentRoute.component().el);
    }
    // 3) 화면 출력 후 스크롤 위치 복구!
    window.scrollTo(0, 0);
}
function $af3cb048de45ff56$export$baddd0131ee8c05b(routes) {
    // 원하는(필요한) 곳에서 호출할 수 있도록 함수 데이터를 반환!
    return function() {
        window.addEventListener("popstate", ()=>{
            $af3cb048de45ff56$var$routeRender(routes);
        });
        $af3cb048de45ff56$var$routeRender(routes);
    };
}
class $af3cb048de45ff56$export$390f32400eaf98c9 {
    constructor(state){
        this.state = {} // 상태(데이터)
        ;
        this.observers = {};
        for(const key in state)// 각 상태에 대한 변경 감시(Setter) 설정!
        Object.defineProperty(this.state, key, {
            // Getter
            get: ()=>state[key],
            // Setter
            set: (val)=>{
                state[key] = val;
                if (Array.isArray(this.observers[key])) // 호출할 콜백이 있는 경우!
                this.observers[key].forEach((observer)=>observer(val));
            }
        });
    }
    // 상태 변경 구독!
    subscribe(key, cb) {
        Array.isArray(this.observers[key]) // 이미 등록된 콜백이 있는지 확인!
         ? this.observers[key].push(cb) // 있으면 새로운 콜백 밀어넣기!
         : this.observers[key] = [
            cb
        ]; // 없으면 콜백 배열로 할당!
    // 예시)
    // observers = {
    //   구독할상태이름: [실행할콜백1, 실행할콜백2]
    //   movies: [cb, cb, cb],
    //   message: [cb]
    // }
    }
}



var $19e44246f9422d81$exports = {};

$19e44246f9422d81$exports = new URL((parcelRequire("27Lyk")).resolve("4uMwD"), import.meta.url).toString();


class $6488ad9fef577b9d$export$2e2bcd8739ae039 extends (0, $af3cb048de45ff56$export$16fa2f45be04daa8) {
    constructor(){
        super({
            tagName: "header",
            state: {
                menus: [
                    {
                        name: "Search",
                        href: "#/"
                    },
                    {
                        name: "Movie",
                        href: "#/movie?id=tt4520988"
                    },
                    {
                        name: "About",
                        href: "#/about"
                    }
                ]
            }
        });
        window.addEventListener("popstate", ()=>{
            this.render();
        });
    }
    render() {
        this.el.innerHTML = /* html */ `
      <a href="#/" class="logo">
        <span>OMDbAPI</span>.COM
      </a>
      <nav>
        <ul>
          ${this.state.menus.map((menu)=>{
            const href = menu.href.split("?")[0];
            const hash = location.hash.split("?")[0];
            const isActive = href === hash;
            return /* html */ `
              <li>
                <a 
                  class="${isActive ? "active" : ""}" 
                  href="${menu.href}">
                  ${menu.name}
                </a>
              </li>
            `;
        }).join("")}
        </ul>
      </nav>
      <a href="#/about" class="user">
        <img src="${0, (/*@__PURE__*/$parcel$interopDefault($19e44246f9422d81$exports))}" alt="User" />
      </a>
    `;
    }
}




var $8f5f19c3bb0d8f98$exports = {};

$8f5f19c3bb0d8f98$exports = new URL((parcelRequire("27Lyk")).resolve("gRhJ5"), import.meta.url).toString();


var $9f00f93a4d28fd0f$export$2e2bcd8739ae039 = new (0, $af3cb048de45ff56$export$390f32400eaf98c9)({
    photo: (0, (/*@__PURE__*/$parcel$interopDefault($8f5f19c3bb0d8f98$exports))),
    name: "JYANG / YangJaeJun",
    email: "yang7134@gmail.com",
    blog: "https://velog.io/@yang7134",
    github: "https://github.com/yangjaejun",
    repository: "https://github.com/yangjaejun/movie-app"
});


class $af4f8136ffd7faf7$export$2e2bcd8739ae039 extends (0, $af3cb048de45ff56$export$16fa2f45be04daa8) {
    constructor(){
        super({
            tagName: "footer"
        });
    }
    render() {
        const { github: github, repository: repository } = (0, $9f00f93a4d28fd0f$export$2e2bcd8739ae039).state;
        this.el.innerHTML = /* html */ `
      <div>
        <a href="${repository}">
          GitHub Repository
        </a>
      </div>
      <div>
        <a href="${github}">
          ${new Date().getFullYear()}
          JYANG
        </a>
      </div>
    `;
    }
}


class $2ae89aad8d89d959$export$2e2bcd8739ae039 extends (0, $af3cb048de45ff56$export$16fa2f45be04daa8) {
    render() {
        const theHeader = new (0, $6488ad9fef577b9d$export$2e2bcd8739ae039)().el;
        const theFooter = new (0, $af4f8136ffd7faf7$export$2e2bcd8739ae039)().el;
        const routerView = document.createElement("router-view");
        this.el.append(theHeader, routerView, theFooter);
    }
}





class $1bf7e69fb47f344b$export$2e2bcd8739ae039 extends (0, $af3cb048de45ff56$export$16fa2f45be04daa8) {
    render() {
        this.el.classList.add("headline");
        this.el.innerHTML = /* html */ `
      <h1>
        <span>OMDb API</span><br>
        THE OPEN<br>
        MOVIE DATABASE
      </h1>
      <p>
        The OMDb API is a RESTful web service to obtain movie information, 
        all content and images on the site are contributed and maintained by our users.<br>
        If you find this service useful, please consider making a one-time donation or become a patron.
      </p>
    `;
    }
}




const $6519604fa6fd3eb8$var$store = new (0, $af3cb048de45ff56$export$390f32400eaf98c9)({
    searchText: "",
    page: 1,
    pageMax: 1,
    movies: [],
    movie: {},
    loading: false,
    message: "Search for the movie title!"
});
var $6519604fa6fd3eb8$export$2e2bcd8739ae039 = $6519604fa6fd3eb8$var$store;
const $6519604fa6fd3eb8$export$b0c4d3ac9887d994 = async (page)=>{
    $6519604fa6fd3eb8$var$store.state.loading = true;
    $6519604fa6fd3eb8$var$store.state.page = page;
    if (page === 1) {
        $6519604fa6fd3eb8$var$store.state.movies = [];
        $6519604fa6fd3eb8$var$store.state.message = "";
    }
    try {
        const res = await fetch("/api/movie", {
            method: "POST",
            body: JSON.stringify({
                title: $6519604fa6fd3eb8$var$store.state.searchText,
                page: page
            })
        });
        const { Search: Search, totalResults: totalResults, Response: Response, Error: Error } = await res.json();
        if (Response === "True") {
            $6519604fa6fd3eb8$var$store.state.movies = [
                ...$6519604fa6fd3eb8$var$store.state.movies,
                ...Search
            ];
            $6519604fa6fd3eb8$var$store.state.pageMax = Math.ceil(Number(totalResults) / 10);
        } else $6519604fa6fd3eb8$var$store.state.message = Error;
    } catch (error) {
        console.error("searchMovies error: ", error);
    } finally{
        $6519604fa6fd3eb8$var$store.state.loading = false;
    }
};
const $6519604fa6fd3eb8$export$e7daf9f9f7371f9a = async (id)=>{
    try {
        const res = await fetch("/api/movie", {
            method: "POST",
            body: JSON.stringify({
                id: id
            })
        });
        $6519604fa6fd3eb8$var$store.state.movie = await res.json();
    } catch (error) {
        console.log("getMovieDetails error: ", error);
    }
};


class $20431fda5c575689$export$2e2bcd8739ae039 extends (0, $af3cb048de45ff56$export$16fa2f45be04daa8) {
    render() {
        this.el.classList.add("search");
        this.el.innerHTML = /* html */ `
      <input 
        value="${(0, $6519604fa6fd3eb8$export$2e2bcd8739ae039).state.searchText}" 
        placeholder="Enter the movie title to search!" />
      <button class="btn btn-primary">
        Search!
      </button>
    `;
        const inputEl = this.el.querySelector("input");
        inputEl?.addEventListener("input", ()=>{
            (0, $6519604fa6fd3eb8$export$2e2bcd8739ae039).state.searchText = inputEl.value;
        });
        inputEl?.addEventListener("keydown", (e)=>{
            if (e.key === "Enter" && (0, $6519604fa6fd3eb8$export$2e2bcd8739ae039).state.searchText.trim()) (0, $6519604fa6fd3eb8$export$b0c4d3ac9887d994)(1);
        });
        const btnEl = this.el.querySelector("button");
        btnEl?.addEventListener("click", (e)=>{
            if ((0, $6519604fa6fd3eb8$export$2e2bcd8739ae039).state.searchText.trim()) (0, $6519604fa6fd3eb8$export$b0c4d3ac9887d994)(1);
        });
    }
}





class $1c75024113bbd448$export$2e2bcd8739ae039 extends (0, $af3cb048de45ff56$export$16fa2f45be04daa8) {
    constructor(props){
        super({
            props: props,
            tagName: "a"
        });
    }
    render() {
        const { movie: movie } = this.props;
        this.el.setAttribute("href", `#/movie?id=${movie.imdbID}`);
        this.el.classList.add("movie");
        this.el.style.backgroundImage = `url(${movie.Poster})`;
        this.el.innerHTML = /* html */ `
      <div class="info">
        <div class="year">
          ${movie.Year}
        </div>
        <div class="title">
          ${movie.Title}
        </div>
      </div>
    `;
    }
}


class $7a11c170c3fb4054$export$2e2bcd8739ae039 extends (0, $af3cb048de45ff56$export$16fa2f45be04daa8) {
    constructor(){
        super();
        (0, $6519604fa6fd3eb8$export$2e2bcd8739ae039).subscribe("movies", ()=>{
            this.render();
        });
        (0, $6519604fa6fd3eb8$export$2e2bcd8739ae039).subscribe("loading", ()=>{
            this.render();
        });
        (0, $6519604fa6fd3eb8$export$2e2bcd8739ae039).subscribe("message", ()=>{
            this.render();
        });
    }
    render() {
        this.el.classList.add("movie-list");
        this.el.innerHTML = /* html */ `
      ${(0, $6519604fa6fd3eb8$export$2e2bcd8739ae039).state.message ? `<div class="message">${(0, $6519604fa6fd3eb8$export$2e2bcd8739ae039).state.message}</div>` : '<div class="movies"></div>'}
      <div class="the-loader hide"></div>
    `;
        const moviesEl = this.el.querySelector(".movies");
        moviesEl?.append(...(0, $6519604fa6fd3eb8$export$2e2bcd8739ae039).state.movies.map((movie)=>new (0, $1c75024113bbd448$export$2e2bcd8739ae039)({
                movie: movie
            }).el));
        const loaderEl = this.el.querySelector(".the-loader");
        (0, $6519604fa6fd3eb8$export$2e2bcd8739ae039).state.loading ? loaderEl?.classList.remove("hide") : loaderEl?.classList.add("hide");
    }
}




class $3ebe9f9f5c4af79c$export$2e2bcd8739ae039 extends (0, $af3cb048de45ff56$export$16fa2f45be04daa8) {
    constructor(){
        super({
            tagName: "button"
        });
        (0, $6519604fa6fd3eb8$export$2e2bcd8739ae039).subscribe("pageMax", ()=>{
            const { page: page, pageMax: pageMax } = (0, $6519604fa6fd3eb8$export$2e2bcd8739ae039).state;
            pageMax > page ? this.el.classList.remove("hide") : this.el.classList.add("hide");
        });
    }
    render() {
        this.el.classList.add("btn", "view-more", "hide");
        this.el.textContent = "View More..";
        this.el.addEventListener("click", async (e)=>{
            this.el.classList.add("hide");
            await (0, $6519604fa6fd3eb8$export$b0c4d3ac9887d994)((0, $6519604fa6fd3eb8$export$2e2bcd8739ae039).state.page + 1);
        });
    }
}


class $8f966fc6c3ddd7f9$export$2e2bcd8739ae039 extends (0, $af3cb048de45ff56$export$16fa2f45be04daa8) {
    render() {
        const headline = new (0, $1bf7e69fb47f344b$export$2e2bcd8739ae039)().el;
        const search = new (0, $20431fda5c575689$export$2e2bcd8739ae039)().el;
        const movieList = new (0, $7a11c170c3fb4054$export$2e2bcd8739ae039)().el;
        const movieListMore = new (0, $3ebe9f9f5c4af79c$export$2e2bcd8739ae039)().el;
        this.el.classList.add("container");
        this.el.append(headline, search, movieList, movieListMore);
    }
}




class $9e7e61b7f62dc712$export$2e2bcd8739ae039 extends (0, $af3cb048de45ff56$export$16fa2f45be04daa8) {
    async render() {
        this.el.classList.add("container", "the-movie");
        this.el.innerHTML = /* html */ `
      <div class="poster skeleton"></div>
      <div class="specs">
        <div class="title skeleton"></div>
        <div class="labels skeleton"></div>
        <div class="plot skeleton"></div>
      </div>
    `;
        await (0, $6519604fa6fd3eb8$export$e7daf9f9f7371f9a)(history.state.id);
        const { movie: movie } = (0, $6519604fa6fd3eb8$export$2e2bcd8739ae039).state;
        const bigPoster = movie.Poster.replace("SX300", "SX700");
        this.el.innerHTML = /* html */ `
      <div 
        style="background-image: url(${bigPoster})" 
        class="poster">
      </div>
      <div class="specs">
        <div class="title">
          ${movie.Title}
        </div>
        <div class="labels">
          <span>${movie.Released}</span>
          &nbsp;/&nbsp;
          <span>${movie.Runtime}</span>
          &nbsp;/&nbsp;
          <span>${movie.Country}</span>
        </div>
        <div class="plot">
          ${movie.Plot}
        </div>
        <div>
          <h3>Ratings</h3>
          ${movie.Ratings.map((rating)=>{
            return /* html */ `
              <p>
                ${rating.Source} - ${rating.Value}
              </p>
            `;
        }).join("")}
        </div>
        <div>
          <h3>Actors</h3>
          <p>${movie.Actors}</p>
        </div>
        <div>
          <h3>Director</h3>
          <p>${movie.Director}</p>
        </div>
        <div>
          <h3>Production</h3>
          <p>${movie.Production}</p>
        </div>
        <div>
          <h3>Genre</h3>
          <p>${movie.Genre}</p>
        </div>
      </div>

    `;
    }
}




class $c06da9a08b0e3020$export$2e2bcd8739ae039 extends (0, $af3cb048de45ff56$export$16fa2f45be04daa8) {
    render() {
        const { photo: photo, name: name, email: email, blog: blog, github: github } = (0, $9f00f93a4d28fd0f$export$2e2bcd8739ae039).state;
        this.el.classList.add("container", "about");
        this.el.innerHTML = /* html */ `
      <div 
        class="photo" 
        style="background-image:url(${photo})">
      </div>
      <p class="name">${name}</p>
      <p>
        <a 
          href="https://mail.google.com/mail/?view=cm&fs=1&to=${email}" 
          target="_blank">${email}
        </a>
      </p>
      <p><a href="${github}" target="_blank">GitHub</a></p>
      <p><a href="${blog}" target="_blank">Blog</a></p>
      
    `;
    }
}



class $651330ec7a632937$export$2e2bcd8739ae039 extends (0, $af3cb048de45ff56$export$16fa2f45be04daa8) {
    render() {
        this.el.classList.add("container", "not-found");
        this.el.innerHTML = /* html */ `
      <h1>
        Sorry..<br>
        Page Not Found.
      </h1>
    `;
    }
}


var $573f2dca97842810$export$2e2bcd8739ae039 = (0, $af3cb048de45ff56$export$baddd0131ee8c05b)([
    {
        path: "#/",
        component: (0, $8f966fc6c3ddd7f9$export$2e2bcd8739ae039)
    },
    {
        path: "#/movie",
        component: (0, $9e7e61b7f62dc712$export$2e2bcd8739ae039)
    },
    {
        path: "#/about",
        component: (0, $c06da9a08b0e3020$export$2e2bcd8739ae039)
    },
    {
        path: ".*",
        component: (0, $651330ec7a632937$export$2e2bcd8739ae039)
    }
]);


const $ad2bcec7a0192558$var$root = document.querySelector("#root");
$ad2bcec7a0192558$var$root?.append(new (0, $2ae89aad8d89d959$export$2e2bcd8739ae039)().el);
(0, $573f2dca97842810$export$2e2bcd8739ae039)();


//# sourceMappingURL=index.31053e86.js.map
